<template>
  <div class="float-right">
    <q-avatar icon="info" font-size="2rem" size="2rem" @click.stop="openInfo">
    </q-avatar>

    <q-dialog v-model="infoDialog">
      <q-card>
        <q-toolbar>
          <q-avatar class="bg-primary">
            <img src="../assets/selo-tj-white.png" />
          </q-avatar>

          <q-toolbar-title
            ><span class="text-weight-bold">Demandas</span>
            Recorrentes</q-toolbar-title
          >

          <q-btn flat round dense icon="close" v-close-popup />
        </q-toolbar>

        <q-card-section>
          <b> Aplicativo:</b> {{ appInfo.name }} <br />
          <b>Função:</b> {{ appInfo.desc }} <br />
          <b>Criadores:</b> {{ appInfo.createdBy }} <br />
          <b>Gerenciadores:</b> {{ appInfo.managers }} <br />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup>
import {ref} from "vue"
const appInfo = {name: "Demandas Recorrentes"}
const infoDialog = ref(false)
const openInfo = () => infoDialog.value = true

</script>
